<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--협의체 정보-->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 협의체 정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">협의일</div>
          <p v-if="isPrint" class="print-input flex-1">
            {{ form.inputA_2 }}
          </p>
          <div v-else class="flex-1 flex items-center">
            <date-selector
              class="w-full"
              v-model="form.inputA_2"
              :readonly="board.readonly"
            />
          </div>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">회의장소</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <vs-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_3"
            class="w-full flex-1"
          ></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">노측 위원(명)</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_4 }}</p>
          <comma-input
            v-else
            :readonly="board.readonly"
            v-model="form.inputA_4"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사측 위원(명)</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_5 }}</p>
          <comma-input
            v-else
            :readonly="board.readonly"
            v-model="form.inputA_5"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

    <!-- 노·사협의체(사용자) -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="노·사협의체(사용자)"
      :tableData="[
        { id: 'cell1', title: '소속명', type: 'text', placeholder: '내용' },
        {
          id: 'cell2',
          title: '직책',
          type: 'select',
          selectData: [
            '사용자대표',
            '안전관리자',
            '보건관리자',
            '관리감독자',
            '사용자위원',
            '기타',
          ],
          placeholder: '선택',
        },
        { id: 'cell3', title: '이름', type: 'text', placeholder: '내용' },
        { id: 'cell4', title: '서명', type: 'text', placeholder: '내용' },
        { id: 'cell5', title: '비고', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.userTableList"
    />

    <!-- 위험성평가협의회(근로자) -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="위험성평가협의회(근로자)"
      :tableData="[
        { id: 'cell1', title: '소속명', type: 'text', placeholder: '내용' },
        {
          id: 'cell2',
          title: '직책',
          type: 'select',
          selectData: [
            '근로자대표',
            '명예산업안전감독관',
            '근로자위원',
            '기타',
          ],
          placeholder: '선택',
        },
        { id: 'cell3', title: '이름', type: 'text', placeholder: '내용' },
        { id: 'cell4', title: '서명', type: 'text', placeholder: '내용' },
        { id: 'cell5', title: '비고', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.workerTableList"
    />

    <!-- 노·사협의체(심의·의결사항, 안전계획 등) 협의내용  -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5>
            <i class="dot"></i> 노·사협의체(심의·의결사항, 안전계획 등) 협의내용
          </h5>
        </vs-col>
      </vs-row>

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대상기간</div>
          <p v-if="isPrint" class="print-input flex-1">
            {{ form.inputB_1 }} ~ {{ form.inputB_2 }}
          </p>
          <div v-else class="flex-1 flex items-center">
            <date-selector
              class="w-full flex-1"
              v-model="form.inputB_1"
              :readonly="board.readonly"
            />
            <p class="px-2">~</p>
            <date-selector
              class="w-full flex-1"
              v-model="form.inputB_2"
              :readonly="board.readonly"
            />
          </div>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">재해형태(필수)</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_3 }}</p>
          <disaster-class-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputB_3"
            :readonly="board.readonly"
          />
        </div>
      </div>
      <div class="print-container flex items-start mt-4">
        <div class="label-text mr-4 mt-2">노·사협의체 구성</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputB_4 }}</p>
        <vs-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_4"
          :readonly="board.readonly"
        />
      </div>
      <div class="print-container flex items-start">
        <div class="label-text mr-4 mt-2">노·사협의체 운영</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputB_5 }}</p>
        <vs-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_5"
          :readonly="board.readonly"
        />
      </div>
      <div class="print-container flex items-start">
        <div class="label-text mr-4 mt-2">노·사합동안전점검</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputB_6 }}</p>
        <vs-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_7"
          :readonly="board.readonly"
        />
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mb-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">작업시간</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_8 }}</p>
          <time-selector v-else class="w-full flex-1" :readonly="board.readonly" v-model="form.inputB_8" />
        </div>
      </div>
      <div class="print-container flex items-start">
        <div class="label-text mr-4 mt-2">작업장 간의 연락방법</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputB_9 }}</p>
        <vs-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_9"
          :readonly="board.readonly"
        />
      </div>
      <div class="print-container flex items-start">
        <div class="label-text mr-4 mt-2">산업재해 예방계획 수립에 관한 사항</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputB_10 }}</p>
        <vs-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_10"
          :readonly="board.readonly"
        />
      </div>
      <div class="print-container flex items-start">
        <div class="label-text mr-4 mt-2">안전보건관리규정 작성 및 변경 사항</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputB_11 }}</p>
        <vs-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_11"
          :readonly="board.readonly"
        />
      </div>
      <div class="print-container flex items-start">
        <div class="label-text mr-4 mt-2">근로자의 안전보건교육 사항</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputB_12 }}</p>
        <vs-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputB_12"
          :readonly="board.readonly"
        />
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector";
import TimeSelector from "@/components/selector/TimeSelector";
import TableInspect from "@/components/TableInspect";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import CompanySelector from "@/components/selector/CompanySelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelector from "@/components/selector/FieldSelector";
import TableCustom from "@/components/TableCustom";

export default {
  components: {
    FieldSelector,
    FieldSelectModule,
    DateSelector,
    TimeSelector,
    TableInspect,
    PhotoUploadGridModule,
    FileUploadModule,
    CompanySelector,
    DisasterClassSelector,
    TableCustom,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];

            if (key === "userTableList" && 0 < value[key].length) {
              this.userTempId = value[key][value[key].length - 1].id;
            }
            if (key === "workerTableList" && 0 < value[key].length) this.workerTempId = value[key][value[key].length - 1].id;
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          노사협의체_사업장명: [],
          노사협의체_재해형태: [],
        };

        value.summary["노사협의체_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["노사협의체_재해형태"].push({
          [this.form.inputB_3]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        userTableList: [],
        workerTableList: [],
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",
        inputB_10: "",
        inputB_11: "",
        inputB_12: "",
        photoList: [],
        fileList: [],
        fieldTitle: "",
      },
      userSelected: [],
      workerSelected: [],
      userTempId: 0,
      workerTempId: 0,
    };
  },
  methods: {
    addTableRow(type) {
      this.form[type].push({
        id: type === "userTableList" ? ++this.userTempId : ++this.workerTempId,
        cell1: "",
        cell2: "",
        cell3: "",
        cell4: "",
        cell5: "",
      });
    },
    deleteSelectTable(type) {
      const selectedIds = type === "userTableList" ? this.userSelected.map((item) => item.id) : this.workerSelected.map((item) => item.id);
      this.form[type] = this.form[type].filter(
        (item) => !selectedIds.includes(item.id)
      );
    },
    onChangeField(field) {
      this.form.fieldTitle = field.field_name;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 4px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}

.table ::v-deep {
  .vs-con-tbody {
    background: none !important;
    border: 0 !important;
  }
  thead tr {
    background: #f9f9f9 !important;
    border-top: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
  }
  tr {
    background: #fff !important;
    border-bottom: solid 1px #cdcdcd;
  }
}
</style>
